export default {
  "notifications": {
    "followed_you": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["követ téged"])},
    "notifications": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Értesítések"])},
    "read": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Olvasva!"])}
  }
}